import {
  TradeDirection,
  TradeFlow,
} from '../../graphQL/types/shared';
import {
  IExportImportDatum,
} from './Utils';

const clamp = (input: number) => (input > 0) ? input : 0;

export type TradeValueGetter = (input: IExportImportDatum) => number;

const getTradeValueAndLabelGetter =
  (tradeDirection: TradeDirection, tradeFlow: TradeFlow): TradeValueGetter => {
    if (tradeDirection === TradeDirection.export) {
      if (tradeFlow === TradeFlow.Gross) {
        return ({export_value}: IExportImportDatum) => clamp(export_value);
      } else {
        return ({export_value, import_value}: IExportImportDatum) => clamp(export_value - import_value);

      }
    } else {
      if (tradeFlow === TradeFlow.Gross) {
        return ({import_value}: IExportImportDatum) => clamp(import_value);
      } else {
        return ({export_value, import_value}: IExportImportDatum) => clamp(import_value - export_value);
      }
    }
};

export default getTradeValueAndLabelGetter;
